import useSWR from 'swr'

import { ErrorState } from '@/components/ErrorState'
import { Skeleton } from '@/components/ui/skeleton'
import { apiFetcher } from '@/data/fetcher'
import { DocumentSequenceForm } from '@/forms/DocumentSequenceForm/DocumentSequenceForm'
import { DocumentType } from '@/types/DocumentType'

export interface DocumentSequencesProps {
  type: DocumentType
  onSaveSuccess?: () => void
}

function toDefaultValues(row: any): Record<string, string> {
  const yearMatch = row.format.match(/^(Y)/i)
  const monthMatch = row.format.match(/^Y?m/i)
  const rest = row.format.match(/^Y?m?(.*)/i)

  return {
    prefix: row.prefix,
    year: yearMatch ? yearMatch[1] : '',
    month: monthMatch ? monthMatch[1] : '',
    suffix: rest ? rest[1] : '',
    exp: Math.pow(10, Number(row.sequenceLength) - 1).toString(),
    default: row.default,
  }
}

export const DocumentSequences = (props: DocumentSequencesProps) => {
  const { data, isLoading, error, mutate } = useSWR(
    `/api/v2/document-sequences?type=${props.type}`,
    apiFetcher,
  )

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-20 w-full rounded-lg" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-2/3" />
      </div>
    )
  }

  if (error) {
    return <ErrorState>{error.message}</ErrorState>
  }

  return (
    <DocumentSequenceForm
      id={data?.data[0]?.id || undefined}
      type={props.type}
      defaultValues={
        data?.data.length ? (toDefaultValues(data.data[0]) as any) : undefined
      }
      onSaveSuccess={() => {
        mutate()
        props.onSaveSuccess?.()
      }}
    />
  )
}
